import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Hidden,
  Button,
  ButtonGroup,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import { setCurrentPage, getByAreaData } from "actions";
import * as C from "components";
import ByAreaSummary from "components/PicTree/Game/Area/ByAreaSummary";
import ByAreaDetailTable from "components/PicTree/Game/Area/ByAreaDetailTable";
import ByAreaMap from "components/PicTree/Game/Area/ByAreaMap";
import CalendarRangePicker from "components/Calendar/CalendarRangePicker";
import CalendarRangePicTreeNtt from "components/Calendar/CalendarRangePicTreeNtt";
import CalendarRangePicTreeNttFt from "components/Calendar/CalendarRangePicTreeNttFt";
import CalendarRangePicTreeHokuden from "components/Calendar/CalendarRangePicTreeHokuden";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
    tableModeBar: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginBottom: theme.spacing(1),
    },
    modeButton: {
      minWidth: 72,
    },
  })
);

const PicTreePhotoByArea = ({
  currentPage,
  setCurrentPage,
  pageTopLoader,
  dateRangePicTree,
  dateRangePicTreeNtt,
  dateRangePicTreeNttFt,
  dateRangePicTreeHokuden,
  getByAreaData,
  byAreaDataSummaryTepco,
  byAreaDataTableTepco,
  byAreaDataSummaryNtt,
  byAreaDataTableNtt,
  byAreaDataRowsNtt,
  byAreaDataSummaryNttFt,
  byAreaDataTableNttFt,
  byAreaDataSummaryHokuden,
  byAreaDataTableHokuden,
  selectedAreaLayerId,
}) => {
  const classes = useStyles();
  const location = useLocation();
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [company, setCompany] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [mapRows, setMapRows] = useState(null);
  const [companyLbl, setCompanyLbl] = useState(null);
  const [viewMode, setViewMode] = useState("table");
  const isNtt = company === "ntt";
  const isMapAllowed =
    isNtt && ["regular_1_l1", "regular_1_l3"].includes(selectedAreaLayerId);

  useEffect(() => {
    setInitialDataCall(true);
    setCurrentPage(location.pathname);
    const seg = location.pathname.split("/");
    const nextCompany = seg[3] || null;
    setCompany(nextCompany);
    setSummaryData(null);
    setTableData(null);
    setMapRows(null);

    if (nextCompany === "ntt") {
      setCompanyLbl("NTT ME");
    } else if (nextCompany === "ntt-ft") {
      setCompanyLbl("NTT FT");
    } else {
      setCompanyLbl(nextCompany ? nextCompany.toUpperCase() : null);
    }
    setViewMode("table");
    getByAreaData(nextCompany);
  }, [location.pathname]);

  // useEffect(() => {
  //   if (
  //     dateRangePicTree[0] !== null &&
  //     dateRangePicTree[1] !== null &&
  //     company !== null &&
  //     initialDataCall
  //   ) {
  //     getByAreaData(company);
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTree]);

  // useEffect(() => {
  //   if (
  //     dateRangePicTreeNtt[0] !== null &&
  //     dateRangePicTreeNtt[1] !== null &&
  //     company !== null &&
  //     initialDataCall
  //   ) {
  //     getByAreaData(company);
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTreeNtt]);

  // useEffect(() => {
  //   if (
  //     dateRangePicTreeNttFt[0] !== null &&
  //     dateRangePicTreeNttFt[1] !== null &&
  //     company !== null &&
  //     initialDataCall
  //   ) {
  //     getByAreaData(company);
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTreeNttFt]);

  useEffect(() => {
    if (!isMapAllowed && viewMode === "map") {
      setViewMode("table");
    }
  }, [isMapAllowed, viewMode]);

  useEffect(() => {
    if (company === "tepco") {
      setSummaryData(byAreaDataSummaryTepco);
      setTableData(byAreaDataTableTepco);
      setMapRows(null);
    } else if (company === "ntt") {
      setSummaryData(byAreaDataSummaryNtt);
      setTableData(byAreaDataTableNtt);
      setMapRows(byAreaDataRowsNtt);
    } else if (company === "ntt-ft") {
      setSummaryData(byAreaDataSummaryNttFt);
      setTableData(byAreaDataTableNttFt);
      setMapRows(null);
    } else if (company === "hokuden") {
      setSummaryData(byAreaDataSummaryHokuden);
      setTableData(byAreaDataTableHokuden);
      setMapRows(null);
    }
  }, [
    byAreaDataSummaryTepco,
    byAreaDataTableTepco,
    byAreaDataSummaryNtt,
    byAreaDataTableNtt,
    byAreaDataRowsNtt,
    byAreaDataSummaryNttFt,
    byAreaDataTableNttFt,
    byAreaDataSummaryHokuden,
    byAreaDataTableHokuden,
  ]);

  const handleChangeViewMode = (mode) => {
    if (mode === "map" && !isMapAllowed) {
      return;
    }
    setViewMode(mode);
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée {companyLbl}</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">エリア別</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            {company && (
              <>
                {company === "tepco" && (
                  <CalendarRangePicker mDate={"2024/04/13"} page="by-area" pictree />
                )}
                {company === "ntt" && (
                  <CalendarRangePicTreeNtt mDate={"2024/04/13"} page="pictree-ntt" pictree />
                )}
                {company === "ntt-ft" && (
                  <CalendarRangePicTreeNttFt mDate={"2024/04/13"} page="pictree-ntt" pictree />
                )}
                {company === "hokuden" && (
                  <CalendarRangePicTreeHokuden mDate={"2024/04/13"} page="pictree-hokuden" pictree />
                )}
              </>
            )}
          </Grid>
        </Grid>

        <Hidden smDown>
          <Grid
            container
            justifyContent="center"
            spacing={0}
            style={{ marginTop: 0 }}
          >
            <Grid item xs={12} md={12} lg={10}>
              <Card>
                <CardContent>
                  <div className={classes.cardContentSection}>
                    <ByAreaSummary data={summaryData} />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Hidden>

        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="center"
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={10}
            style={{ marginTop: 0, justifyContent: "center" }}
          >
            {isNtt && (
              <div className={classes.tableModeBar}>
                <ButtonGroup size="small" variant="outlined" color="primary">
                  <Button
                    className={classes.modeButton}
                    onClick={() => handleChangeViewMode("table")}
                    variant={viewMode === "table" ? "contained" : "outlined"}
                    color={viewMode === "table" ? "primary" : "default"}
                  >
                    一覧表示
                  </Button>
                  <Button
                    className={classes.modeButton}
                    onClick={() => handleChangeViewMode("map")}
                    variant={viewMode === "map" ? "contained" : "outlined"}
                    color={viewMode === "map" ? "primary" : "default"}
                    disabled={!isMapAllowed}
                  >
                    地図表示
                  </Button>
                </ButtonGroup>
              </div>
            )}
            {viewMode === "map" && isMapAllowed ? (
              <ByAreaMap data={mapRows} />
            ) : (
              <ByAreaDetailTable data={tableData} />
            )}
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreePhotoByArea.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTree: state.page.dateRangePicTree,
  dateRangePicTreeNtt: state.page.dateRangePicTreeNtt,
  dateRangePicTreeNttFt: state.page.dateRangePicTreeNttFt,
  dateRangePicTreeHokuden: state.page.dateRangePicTreeHokuden,
  byAreaDataSummaryTepco: state.pictree.byAreaDataSummary,
  byAreaDataTableTepco: state.pictree.byAreaDataTable,
  byAreaDataSummaryNtt: state.pictreeNtt.byAreaDataSummary,
  byAreaDataTableNtt: state.pictreeNtt.byAreaDataTable,
  byAreaDataRowsNtt: state.pictreeNtt.byAreaDataRows,
  byAreaDataSummaryNttFt: state.pictreeNttFt.byAreaDataSummary,
  byAreaDataTableNttFt: state.pictreeNttFt.byAreaDataTable,
  byAreaDataSummaryHokuden: state.pictreeHokuden.byAreaDataSummary,
  byAreaDataTableHokuden: state.pictreeHokuden.byAreaDataTable,
  selectedAreaLayerId: state.pictreeNtt.selectedAreaLayerId,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getByAreaData: (param) => dispatch(getByAreaData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreePhotoByArea));
